import React from 'react'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router } from 'react-router-dom'
import './assets/main.css'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'

Modal.setAppElement('#root')

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Toaster />
        <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
